import React, { useEffect, useState } from "react";
import "./MobileAccordionSection.css"

function useMediaQuery(query: string) {
    const getMatch = () =>
        typeof window !== "undefined" && window.matchMedia
            ? window.matchMedia(query).matches
            : false;

    const [matches, setMatches] = useState(getMatch);

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = () => setMatches(mql.matches);

        onChange();
        mql.addEventListener?.("change", onChange);
        return () => mql.removeEventListener?.("change", onChange);
    }, [query]);

    return matches;
}

type MobileCollapseSectionProps = {
    title: string;
    startOpen?: boolean;
    children: React.ReactNode;
};

export function MobileCollapseSection({
                                          title,
                                          startOpen = false,
                                          children,
                                      }: MobileCollapseSectionProps) {
    const isMobile = useMediaQuery("(max-width: 768px)");

    // On desktop: always open. On mobile: controlled by user, initial from startOpen.
    const [open, setOpen] = useState(startOpen);

    useEffect(() => {
        if (!isMobile) setOpen(true);
        else setOpen(startOpen);
    }, [isMobile, startOpen]);

    if (!isMobile) {
        return (
            <section className="mcs mcs-desktop">
                <h4 className="mcs-title pt-2">{title}</h4>
                <div className="mcs-body">{children}</div>
            </section>
        );
    }

    return (
        <section className="mcs mcs-mobile mt-1">
            <button
                type="button"
                className="btn btn-outline-info mcs-header"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
            >
                <span className="mcs-title">{title}</span>
                <span className={`mcs-chevron ${open ? "open" : ""}`} aria-hidden="true">
          ▾
        </span>
            </button>
            {open && <div className="mcs-body">{children}</div>}
        </section>
    );
}
